const CITIES = [
  { name: "Kinshasa", x: 230, y: 340, primary: true },
  { name: "Matadi", x: 100, y: 300 },
  { name: "Goma", x: 290, y: 320 },
  { name: "Lubumbashi", x: 275, y: 410 },
  { name: "Nairobi", x: 340, y: 260 },
  { name: "Dakar", x: 150, y: 120 },
  { name: "Le Caire", x: 320, y: 110 },
];

const BEAMS = [
  { d: "M230 340 Q252 302 100 300", delay: "0s", color: "#FDB022" },
  { d: "M230 340 Q252 306 290 320", delay: "0.3ss", color: "#FDB022" },
  { d: "M230 340 Q273.5 361.5 275 410", delay: "0.6s", color: "#FB7185" },
  { d: "M230 340 Q152 244 150 120", delay: "1.2s", color: "#38BDF8" },
  { d: "M230 340 Q267 276 340 260", delay: "1.8s", color: "#10B981" },
  { d: "M340 260 Q295 190 320 110", delay: "2.4s", color: "#FDB022" },
];

export default function AfricaMap() {
  return (
    <svg
      className="africa-map"
      viewBox="20 20 480 550"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Carte stylisée de l'Afrique montrant des villes reliées par des connexions animées, représentant le réseau d'élèves connectés à Eskolé"
    >
      <path
        className="africa-shape"
        d="M250 40
           C288.3 40.2 327.5 71 365 91
           C402.5 111 460.8 126.8 475 160
           C489.2 193.2 457.2 250.8 450 290
           C442.8 329.2 446.2 361.8 432 395
           C417.8 428.2 395.3 463.2 365 489
           C334.7 514.8 285.8 554.3 250 550
           C214.2 545.7 177.5 490.5 150 463
           C122.5 435.5 103.3 413.8 85 385
           C66.7 356.2 29.8 315.8 40 290
           C50.2 264.2 130.2 263.3 146 230
           C161.8 196.7 117.7 121.7 135 90
           C152.3 58.3 211.7 39.8 250 40 Z"
      />

      {/* faint base routes */}
      {BEAMS.map((beam) => (
        <path key={`base-${beam.d}`} d={beam.d} className="africa-route-base" fill="none" />
      ))}

      {/* animated flowing beams */}
      {BEAMS.map((beam) => (
        <path
          key={`beam-${beam.d}`}
          d={beam.d}
          pathLength="1"
          className="africa-route-beam"
          fill="none"
          style={{ stroke: beam.color, color: beam.color, animationDelay: beam.delay }}
        />
      ))}

      {/* city markers */}
      {CITIES.map((city) => (
        <g key={city.name} transform={`translate(${city.x} ${city.y})`}>
          <circle className="africa-city-ping" r="6" style={{ color: city.primary ? "#FDB022" : "#4F46E5" }} />
          <circle r={city.primary ? 6 : 4.5} fill={city.primary ? "#FDB022" : "#4F46E5"} stroke="#fff" strokeWidth="2" />
          <text
            x={city.x > 400 ? -10 : 10}
            y="4"
            textAnchor={city.x > 400 ? "end" : "start"}
            className="africa-city-label"
          >
            {city.name}
          </text>
        </g>
      ))}
    </svg>
  );
}
